import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`

export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 4px;
`

export const Description = styled.div`
  font-size: 16px;
`

export const Img = styled.img`
  max-width: 286px;
`

export const ButtonWrapper = styled.div`
  width: 100%;
`
